import { appSlice } from 'modules/app/appSlice';
import { combineReducers } from '@reduxjs/toolkit';

const reducer = combineReducers({
	app: appSlice.reducer,
});

export default reducer;
